export default "/images/adobe.svg?18e56447696e4920ce55f2008547dba4";